import { render, staticRenderFns } from "./shipments.vue?vue&type=template&id=93d7eb80&"
import script from "./shipments.vue?vue&type=script&lang=js&"
export * from "./shipments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports